import axios from "axios";
import { jobRequestBidsUrl } from "../utils";

export const getJobRequestBids = (jobRequestId: string) => {
  return axios.get(jobRequestBidsUrl(jobRequestId));
};
